import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import ConditionalBlock from './ConditionalBlock';

const RecipientsTableRows = ({recipientsLoading, recipients, disabled, isReadOnly, onSendButtonClick}) => {
    if (recipientsLoading) {
        return (
            <tr>
                <td colSpan={10}>
                    <em>{window.__js_general.please_wait}</em>
                </td>
            </tr>
        );
    }

    if (!recipients || recipients.length === 0) {
        return (
            <tr>
                <td colSpan={10}>
                    <em>{window.__js_contracts.no_billing_notification_recipients_registered}</em>
                </td>
            </tr>
        );
    }

    const onButtonClick = (e, recipient) => {
        e.preventDefault();
        onSendButtonClick(recipient);
    }

    return recipients.map((item) => {
        return (
            <tr key={item.id}>
                <td>{item.last_name}</td>
                <td>{item.first_name}</td>
                <td>{item.email}</td>
                <td>{item.last_notified_at}</td>
                <ConditionalBlock show={!isReadOnly}>
                    <td>
                        <button className="btn btn-primary btn-xs" disabled={disabled}
                                onClick={e => onButtonClick(e, item)}>
                            <i className="fa fa-fw fa-envelope"></i>
                            {window.__js_contracts.send}
                        </button>
                    </td>
                </ConditionalBlock>
            </tr>
        );
    });
}

const RecipientsTable = ({recipientsLoading, recipients, disabled, isReadOnly, onSendButtonClick}) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="table-responsive">
                    <table className="table table-striped table-hover table-bordered">
                        <thead>
                        <tr>
                            <th>{window.__js_contracts.surname}</th>
                            <th>{window.__js_contracts.name}</th>
                            <th>Email</th>
                            <th>{window.__js_contracts.latest_notification}</th>
                            <ConditionalBlock show={!isReadOnly}>
                                <th>{window.__js_contracts.actions}</th>
                            </ConditionalBlock>
                        </tr>
                        </thead>
                        <tbody>
                        <RecipientsTableRows
                            recipientsLoading={recipientsLoading}
                            recipients={recipients}
                            disabled={disabled}
                            isReadOnly={isReadOnly}
                            onSendButtonClick={onSendButtonClick}
                        />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default class ContractBillingNotifications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recipientsLoading: false,
            loading: false,
            recipients: [],
        };

        this.onSendButtonClick = this.onSendButtonClick.bind(this);
        this.fetchAllRecipients = this.fetchAllRecipients.bind(this);
    }

    componentDidMount() {
        this.setState({recipientsLoading: true}, () => {
            this.fetchAllRecipients(() => {
                this.setState({recipientsLoading: false});
            });
        });
    }

    fetchAllRecipients(callback) {
        const {fetchAllUrl} = this.props;

        axios
            .get(fetchAllUrl)
            .then(response => {
                this.setState({recipients: response.data}, () => {
                    if (callback) callback();
                });
            });
    }

    onSendButtonClick(recipient) {
        const {notifyUrl} = this.props;

        this.setState({loading: true}, () => {
            axios
                .post(notifyUrl, {recipient_id: recipient.id})
                .then(() => {
                    this.fetchAllRecipients(() => {
                        this.setState({loading: false});
                    });
                })
                .catch(error => {
                    const errors = error.response.data.errors.join('\n');

                    alert(errors);

                    this.fetchAllRecipients(() => {
                        this.setState({loading: false});
                    });
                })
        });
    }

    render() {
        const {isReadOnly} = this.props;
        const {recipientsLoading, loading, recipients} = this.state;

        return (
            <RecipientsTable
                recipients={recipients}
                recipientsLoading={recipientsLoading}
                disabled={loading}
                isReadOnly={isReadOnly}
                onSendButtonClick={this.onSendButtonClick}
            />
        );
    }
}

const element = document.getElementById('contract-billing-notifications');

if (element) {
    const fetchAllUrl = element.getAttribute('data-fetch-all-url');
    const notifyUrl = element.getAttribute('data-notify-url');
    const isReadOnly = (element.getAttribute('data-readonly') === '1');

    ReactDOM.render(
        <ContractBillingNotifications
            fetchAllUrl={fetchAllUrl}
            notifyUrl={notifyUrl}
            isReadOnly={isReadOnly}
        />,
        element
    );
}